import { render, staticRenderFns } from "./CPDueDiligenceAccountHolderPersonalInfoDetails.vue?vue&type=template&id=ddeb831e&scoped=true&"
import script from "./CPDueDiligenceAccountHolderPersonalInfoDetails.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceAccountHolderPersonalInfoDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeb831e",
  null
  
)

export default component.exports